import React, { useEffect, useState } from 'react'
import { ApiService } from '../../../Components/Services/apiServices';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Homeourpartners = () => {

  const [Homeourpartners, setHomeourpartners] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {

    const fetchhomeourpartners = async () => {
      try {
        const homeourpartners = await ApiService.Commanfetchrequest("home-ourpartners");
        setHomeourpartners(homeourpartners);
      } catch (error) {
        console.error("Error While fetching", error);
      } finally {
        setLoading(false);
      }

    }



    fetchhomeourpartners();

  }, [])

  return (
    <>
      {loading ? (
        <section id="clients" className="clients section">
          <div className="container aos-init aos-animate">
            <div className="row gy-4">
              <p className="text-center" style={{ fontSize: 18, fontWeight: 700 }}><Skeleton width={"50%"} height={20} /></p>

              {Array.from({ length: 6 }).map((_, index) => (
                <div className="col-xl-2 col-md-3 col-6 client-logo" key={index}>
                  <Skeleton width={150} height={50}  />
                </div>
              ))}

            </div>
          </div>
        </section>
      ) : (
        <section id="clients" className="clients section">
          <div className="container aos-init aos-animate" data-aos="fade-up">
            <div className="row gy-4">
              <p className="text-center" style={{ fontSize: 18, fontWeight: 700 }}>Trusted by  100+ Organizations Globally</p>

              {Homeourpartners?.map((value, index) => {
                return (
                  <>
                    <div className="col-xl-2 col-md-3 col-6 client-logo" key={index}>
                      <img src={`https://sigohrmlpadmin.loopring.in/front/images/homepartners/${value?.partners_image}`} className="img-fluid" alt />
                    </div>
                  </>
                )
              })}


            </div>
          </div>
        </section>
      )}
    </>

  )
}

export default Homeourpartners
